import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { composeStreetLine } from '@/lib/addressLine';
import { EMPTY_FORM } from './constants';

export function formatIban(value) {
  const cleaned = (value || '').replace(/\s+/g, '').toUpperCase();
  return cleaned.match(/.{1,4}/g)?.join(' ') || '';
}

export function isValidIban(raw) {
  const s = (raw || '').replace(/\s/g, '').toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(s)) return false;
  if (s.startsWith('DE') && s.length !== 22) return false;
  const rearranged = s.slice(4) + s.slice(0, 4);
  let rem = 0;
  for (const ch of rearranged) {
    const v = /\d/.test(ch) ? ch : String(ch.charCodeAt(0) - 55);
    for (const d of v) rem = (rem * 10 + Number(d)) % 97;
  }
  return rem === 1;
}

export function cleanPhoneInput(value) {
  let s = (value || '').replace(/[^\d+\s/]/g, '');
  s = s.replace(/(?!^)\+/g, '');
  return s;
}

export function isValidPhone(value) {
  const s = (value || '').trim();
  if (!s) return false;
  const p = parsePhoneNumberFromString(s, 'DE');
  return !!(p && p.isValid());
}

export function isValidHouseNumber(value) {
  return /^\d+$/.test((value || '').trim());
}

export function blankToNull(value) {
  const s = (value ?? '').toString().trim();
  return s || null;
}

const PAYER_COPY_KEYS = [
  'salutation', 'title', 'first_name', 'last_name', 'gender',
  'email', 'phone',
  'birth_day', 'birth_month', 'birth_year',
  'street', 'house_number', 'address_extra', 'postal_code', 'city', 'district',
];

/** Teilnehmer ist die zahlungspflichtige Person: Name, Anschrift, Kontakt, Geburtsdatum. */
export function studentFromPayer(student, payer) {
  const next = { ...student, same_as_payer: true, address_same: true };
  PAYER_COPY_KEYS.forEach((key) => {
    const value = payer?.[key];
    next[key] = value == null ? '' : value;
  });
  return next;
}

export function payerCopiedLine(payer) {
  const street = composeStreetLine(payer);
  const place = [payer?.postal_code, payer?.city, payer?.district].filter(Boolean).join(' ');
  const contact = [payer?.email, payer?.phone].filter(Boolean).join(' · ');
  return [street, place, contact].filter(Boolean).join(' · ');
}

const KEPT_STUDENT_KEYS = [
  'salutation', 'title', 'first_name', 'last_name',
  'birth_day', 'birth_month', 'birth_year',
  'gender', 'email', 'phone', 'photo_consent',
  'same_as_payer', 'address_same',
  'street', 'house_number', 'address_extra', 'postal_code', 'city', 'district',
];

/**
 * Zweite Anmeldung derselben Familie: Fach neu wählen, Kontakt und
 * Zahlungspflichtigen behalten, Teilnehmer bleibt änderbar.
 */
export function formForAnotherRegistration(form) {
  const student = { ...EMPTY_FORM.student };
  const current = form?.student || {};
  KEPT_STUDENT_KEYS.forEach((key) => {
    if (current[key] != null) student[key] = current[key];
  });
  return {
    ...form,
    student,
    teaching_type: '',
    course_offer: null,
    location_id: '',
    preferred_slot: null,
    availability: [{ weekday: '', from: '', to: '' }],
    group: { priority: '', additional_students: [] },
    consents: { agb: false, datenschutz: false, widerruf: false },
    muensterland_card: { has_card: false, number: '' },
    custom: {},
    fallback_contact: false,
  };
}

/** Normalize "9:00" / "09:00:00" → "09:00" for PreferredSlot validation. */
export function normalizeHhmm(value) {
  const s = (value ?? '').toString().trim();
  if (/^\d{2}:\d{2}:\d{2}$/.test(s)) return s.slice(0, 5);
  const m = s.match(/^(\d{1,2}):(\d{2})$/);
  if (m) return `${m[1].padStart(2, '0')}:${m[2]}`;
  return s || null;
}
